import { ChatMessage } from "app/components/ai-chat-assistant/types";
import { useCallback, useEffect, useRef, useState } from "react";

export function createId(): string {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }
  return String(Date.now());
}

export function useChatMessages() {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [threadId, setThreadId] = useState<string>(() => createId());

  const messagesRef = useRef<ChatMessage[]>(messages);

  useEffect(() => {
    messagesRef.current = messages;
  }, [messages]);

  const appendMessages = useCallback((newMessages: ChatMessage[]) => {
    setMessages((prev) => [...prev, ...newMessages]);
  }, []);

  const updateMessage = useCallback((id: string, content: string) => {
    setMessages((prev) =>
      prev.map((message) =>
        message.id === id
          ? {
            ...message,
            content
          }
          : message
      )
    );
  }, []);

  const clearMessages = useCallback(() => {
    setMessages([]);
    setThreadId(createId()); 
  }, []);

  return {
    messages,
    messagesRef,
    threadId,
    appendMessages,
    updateMessage,
    clearMessages
  };
}
